import { render, staticRenderFns } from "./vue-icon.vue?vue&type=template&id=9d617122&"
import script from "./vue-icon.vue?vue&type=script&lang=js&"
export * from "./vue-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d617122')) {
      api.createRecord('9d617122', component.options)
    } else {
      api.reload('9d617122', component.options)
    }
    module.hot.accept("./vue-icon.vue?vue&type=template&id=9d617122&", function () {
      api.rerender('9d617122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VIcon/vue-icon.vue"
export default component.exports